<template>
<div>
    <!-- <side-bar ref="sideBar" :items="items"></side-bar> -->
      <protocol-banner></protocol-banner>
      <v-container style="min-height:calc(100vh - 172px)" class="">
        <v-fade-transition mode="out-in">
          <!--The Main Content component go here-->
          <router-view></router-view>
        </v-fade-transition>
            <v-fab-transition>
              <v-menu top :offset-y="true" :close-on-content-click="false" :nudge-top="10">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="teal darken-4" class="support-fab animate"
                    dark fixed
                    v-bind="attrs"
                    v-on="on"
                    bottom right fab >
                    <v-icon>mdi-face-agent</v-icon>
                  </v-btn>
                </template>
                <v-card width="300px">
                  <v-card-text>
                    <v-form @submit.prevent="sendFeedback">
                      <v-textarea label="Góp ý" color="teal darken-4" filled hide-details class="mb-3" v-model="feedBack.body">
                      </v-textarea>
                      <v-btn small right class="ml-auto" depressed color="teal darken-4" type="submit" dark> Gởi</v-btn>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-fab-transition>
      </v-container>
</div>
</template>
<script>
import SideBar from "@/components/SideBar.vue";
import Protocol from "@/components/Banner/Protocol.vue";
import http from '@/components/services/http-common';
export default {
    components:{
        SideBar,
        "protocol-banner": Protocol
    },
    computed:{
      webAllowed() {
          let user = localStorage.getItem("user");
          let webAllowed = localStorage.getItem("WebAllowed");
          user = JSON.parse(user);
        return webAllowed.includes(user.employeeCode);
      },
      items(){
          
          let data= [
            { title: "Dashboard", subheader:true},
            { title: "Trang chính", icon: "mdi-view-dashboard-outline", route:{name:'Home'}, auth:'module:base' },
            { title: "Thông tin người thân", icon: "mdi-human-male-child", route:{name:'EmployeeFamily'}, auth:[] },
            { title: "Cập nhật thông tin", icon: "mdi-human-male-child", route:{name:'EmployeeInfoUpdate'}, auth:[] },
            { title: "Truyền thông", subheader:true},
            { title: "Tin tức", icon: "mdi-bullhorn-outline", route:{name:'News'}, auth:'module:base' },
            { title: "Khảo sát", icon: "mdi-vote-outline", route:{name:'SurveyEmployee'}, auth:'module:base'},
            { title: "Danh sách hỗ trợ", icon: "mdi-help-circle-outline", route:{name:"Support"}, auth:['module:base'], webAllowed: true },
            { title: "Thư viện tài liệu", icon: "mdi-bookshelf", route:{name:'ExternalFileManager'}, auth:'module:base'},
            // { title: "Hồ sơ", icon: "mdi-book-account", route:{name:'Profile'}, auth:'module:base'},
            { title: "Điểm danh & chấm công", subheader:true},
            { title: "Chấm công", icon: "mdi-briefcase-clock", route:{name:"Enrollment"}, auth:['module:base'], webAllowed: this.webAllowed},
            // { title: "Phiếu lương", icon: "mdi-bank", route:{name:'EmployeeSalary'}, auth:'module:base'},
            
            { title: "Đơn phiếu yêu cầu", subheader:true},
            // { title: "Tăng ca tối đa", icon: "mdi-clock-alert-outline", route:{name:"OvertimeBooking"}, auth:['module:base', 'otmax:rq'], webAllowed: this.webAllowed},
            { title: "Làm thêm", icon: "mdi-note-text-outline", route:{name:"OvertimeRequest"}, auth:'module:base', webAllowed: true},
            { title: "Công tác", icon: "mdi-note-text-outline", route:{name:"BusinessRequest"}, auth:'module:base', webAllowed: true },
            { title: "Nghỉ phép", icon: "mdi-note-text-outline", route:{name:"LeaveRequest"}, auth:'module:base', webAllowed: true },
            // { title: "Nghỉ dài hạn", icon: "mdi-car-estate", route:{name:"LongLeaveRequest"}, auth:'module:base', webAllowed: true },
            // { title: "Nghỉ việc", icon: "mdi-feather", route:{name:"QuitRequest"}, auth:'module:base', webAllowed: true },
            
            { title: "Mục khác", subheader:true},
            { title: "B/C tổng hợp", icon: "mdi-chart-box-plus-outline", route:{ name: 'StoreReport'}, auth: ["rp:store" ]},
            { title: "Đặt hàng", icon: "mdi-package-variant", route:{name:"BaseDatHang"}, auth:['cm:dathang'], webAllowed: true , badge: 'new'},
            { title: "Phiếu công cụ, dụng cụ", icon: "mdi-toolbox-outline", route:{name:"PropertyRequest"}, auth:['module:base'], webAllowed: true },
            { title: "Tiếp nhận phiếu cc/dc", icon: "mdi-car-estate", route:{name:"PropertyRequestConfirm"}, auth:['module:base', 'prop:receive'], webAllowed: true },
            { title: "B/C hình ảnh", icon: "mdi-camera-outline", route:{ name: 'BaseImageReport'}, auth: [ 'module:base', 'imgRep:index']},
            
            { title: "IT Support 24/7", icon: "mdi-text-box-check", route:{name:"ItSupport"}, auth:[""], webAllowed: true },
          ]
        return this.dbMenus
      }
    },
    data() {
        return {
          feedBack: {
            body:"",
            type: "standard_feedback",
          },
          dbMenus: []
        }
    },
    methods: {
      sendFeedback() {
        return http.post("feedbacks", this.feedBack).then(res => {
          console.log("feedback", res)
        })
      },
      getMenu() {
        return http.get("menus/sections/BASE").then(r => {
          this.dbMenus = r.data.data.map(x => {
            return {
              title: x.title,
              icon: x.icon,
              route: {name: x.routeName},
              auth: x.claims.split(','),
              subheader: x.type == 'SUBHEADER'
            }
          })
          console.log(this.dbMenus)
        })
      }
    },
    beforeMount() {
    },
    mounted(){
    },
    created() {
      this.$emit('loadingSidebar', true)
      this.getMenu().then(() => {
        this.$emit('updateSidebar', this.items);
        this.$emit('loadingSidebar', false)
      })
    }
}
</script>

<style scoped>
.support-fab.animate {
  animation: pulseBounce 1.2s ease-out;
}

@keyframes pulseBounce {
  0% {
    transform: scale(0.6);
    opacity: 0;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
  70% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

</style>